export async function svgSpriteLoader(url: string) {
    if (!url) {
        return;
    }

    const response = await fetch(url);
    const sprite = await response.text();

    const div = document.createElement("div");
    div.id = "sprite-sheet";
    div.style.display = "none";
    div.setAttribute("aria-hidden", "true");
    div.innerHTML = sprite;

    // Only insert if it does not already exist
    const spriteSheet = document.getElementById("sprite-sheet");
    if (!spriteSheet) {
        document.body.insertBefore(div, document.body.childNodes[0]);
    } else {
        // When the spritesheet gets big enough it seems that the fetch request counts as finished if the component re-renders before it is actually finished
        // This causes the sprite loader to insert the 'sprite-sheet' without all icons present.
        // Therefore we have to re-enter the outerHTML of sprite-sheet for each re-render.
        spriteSheet.outerHTML = div.outerHTML;
    }
}
